export default __webpack_public_path__ + "static/media/truck.51c7d74d.webp";